import React, {useEffect, useState} from "react";
import {Box, Divider, Grid, Paper} from "@mui/material";
import LoadingComponent from "./LoadingComponent";
import {useAuth} from "../contexts/AuthContext";
import {useGroup} from "../contexts/GroupContext";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import SendIcon from "@mui/icons-material/Send";
import {makeStyles} from "@mui/styles";
import {firestore} from "../firebase"

function AdminComponent() {

    //State
    const [isReady, setIsReady] = useState(false)
    const [whitelistEmail, setWhitelistEmail] = useState("");
    const [whitelistGroup, setWhitelistGroup] = useState("");
    const [endpoint, setEndpoint] = useState("");
    const [endpointGroup, setEndpointGroup] = useState("");
    const {whitelist} = useAuth();
    const {role} = useGroup();

    const useStyles = makeStyles((theme) => ({
        root: {
            padding: theme.spacing(2),
            flexGrow: 1,
        },
        divider: {
            width: '100%',
            margin: theme.spacing(2, 0),
            backgroundColor: 'transparent !important'
        },
    }));

    const classes = useStyles();

    const handleEmailChange = (event) => {
        setWhitelistEmail(event.target.value);
    };

    const handleGroupChange = (event) => {
        setWhitelistGroup(event.target.value);
    };

    const handleWhitelistSubmit = () => {
        if (role === "admin") {
            if (/\S/.test(whitelistEmail) && /\S/.test(whitelistGroup)) {
                whitelist(whitelistEmail, whitelistGroup);
            } else {
                alert("Please input both an email and a group to whitelist a new user");
            }
        } else {
            alert("You do not have permissions to whitelist new users - please contact support@zeenorobotics.com");
        }
    };

    const generateWhitelist = () => {
        return (
            <>
                <Grid container item spacing={3} xs={11}>
                    <Grid item xs>
                        <Typography>Whitelist new user:</Typography>
                    </Grid>
                    <Grid item xs>
                        <TextField variant='standard' autoComplete='off' onChange={handleEmailChange} id="emailField" label="Email..." fullWidth/>
                    </Grid>
                    <Grid item xs>
                        <TextField variant='standard' autoComplete='off' onChange={handleGroupChange} id="groupField" label="Group..." fullWidth/>
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                    <IconButton onClick={handleWhitelistSubmit}>
                        <SendIcon color="send"/>
                    </IconButton>
                </Grid>
            </>
        )
    };

    const addEndpoint = (newEndpoint, newGroup) => {
        firestore.collection(`groups`).doc(newGroup).set({
            client_endpoint: newEndpoint,
        }).then(() => {
            alert("New endpoint: " + newEndpoint + " added to group: " + newGroup);
        })
    }
    const handleEndpointChange = (event) => {
        setEndpoint(event.target.value);
    };

    const handleEndpointGroupChange = (event) => {
        setEndpointGroup(event.target.value);
    };

    const handleEndpointSubmit = () => {
        if (role === "admin") {
            if (/\S/.test(endpoint) && /\S/.test(endpointGroup)) {
                addEndpoint(endpoint, endpointGroup);
            } else {
                alert("Please input both a client id and a group to add the endpoint");
            }
        } else {
            alert("You do not have permissions to add endpoints - please contact support@zeenorobotics.com");
        }
    };

    const generateClientEndpoint = () => {
        return (
            <>
                <Grid container item spacing={3} xs={11}>
                    <Grid item xs>
                        <Typography>Add client endpoint:</Typography>
                    </Grid>
                    <Grid item xs>
                        <TextField variant='standard' autoComplete='off' onChange={handleEndpointChange} id="endpointField" label="Endpoint..." fullWidth/>
                    </Grid>
                    <Grid item xs>
                        <TextField variant='standard' autoComplete='off' onChange={handleEndpointGroupChange} id="endpointGroupField" label="Group..." fullWidth/>
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                    <IconButton onClick={handleEndpointSubmit}>
                        <SendIcon color={'send'}/>
                    </IconButton>
                </Grid>
            </>
        )
    };

    //If all the data is set, we're ready to render
    useEffect(() => {
        if (role !== undefined) {
            setIsReady(true)
        }
    }, [role])

    if (isReady) {
        return (
            <Box>
                <Grid container spacing={2} mt={1}>
                    <Grid container item spacing={2} lg={12} xs={12}>
                        <Box>
                            <Paper>
                                <Box p={2} display="flex">
                                    <Typography variant="h1">Whitelist New User</Typography>
                                </Box>
                                <Divider className={classes.divider} />
                                <div className={classes.root}>
                                    <Grid container spacing={3}>
                                        {generateWhitelist()}
                                    </Grid>
                                </div>
                            </Paper>
                        </Box>
                    </Grid>
                </Grid>

                <Divider className={classes.divider} />

                <Grid container spacing={2}>
                    <Grid container item spacing={2} lg={12} xs={12}>
                        <Box>
                            <Paper>
                                <Box p={2} display="flex">
                                    <Typography variant="h1">Add Client Endpoint</Typography>
                                </Box>
                                <Divider className={classes.divider} />
                                <div className={classes.root}>
                                    <Grid container spacing={3}>
                                        {generateClientEndpoint()}
                                    </Grid>
                                </div>
                            </Paper>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        )
    } else {
        return (
            <LoadingComponent/>
        )
    }
}

export default AdminComponent;
